import { render, staticRenderFns } from "./NotificationScheduling.vue?vue&type=template&id=0fd1673d&"
import script from "./NotificationScheduling.vue?vue&type=script&lang=ts&"
export * from "./NotificationScheduling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports